import type { Layout } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { RibbonGroupId } from 'owa-ribbon-ids';

export const getMLRFolderTabGroupLayouts: (
    group: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
) => Layout[] | undefined = owaComputedFn(function getMLRFolderTabGroupLayouts(
    _group: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
): Layout[] | undefined {
    return undefined;
});
